import React, { useState, useEffect, useCallback } from "react";
import useStyles from "./style";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

//Services
import AvailablebanksApi from "Services/Availablebanks";

const ServiceDelete = (props) => {
  const { openDialog, id, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [bankName, setBankName] = useState(null);

  // Fetch Bank Details
  const getDetails = useCallback(() => {
    if (!id) return;
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setBankName(res?.data?.data?.bankName);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    AvailablebanksApi.getBankDetailsbyId(id).then(onSuccess, onFailure);
  }, [id, dispatch]);

  useEffect(() => {
    if (openDialog) {
      getDetails();
    }
  }, [openDialog, getDetails]);

  const handleDeleteBank = () => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: "Bank Deleted Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        handleClose();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while deleting bank",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    AvailablebanksApi.deleteBank(id).then(onSuccess, onFailure);
  };

  return (
    <Dialog
      open={openDialog}
      onClose={handleClose}
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle className={classes.dialogTitle}>Delete Bank</DialogTitle>
      <DialogContent style={{ padding: 0 }}>
        <DialogContentText className={classes.dialogContentText}>
          Are you sure you want to delete the bank{" "}
          <strong>{bankName || "this bank"}</strong>? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ padding: 0 }}>
        <Button className={classes.cancelButton} onClick={handleClose}>
          Cancel
        </Button>
        <Button className={classes.deleteButton} onClick={handleDeleteBank} autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ServiceDelete;
